// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","container":"EnterGoal_container__ZnFaz","continue":"EnterGoal_continue__CF0LH"};